import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/config";
import { getUserProfile, logoutUser, setAuditActor } from "../firebase/services";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);       // Firebase auth user
  const [profile, setProfile] = useState(null); // Firestore user doc
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        setLoading(true); // giữ loading=true trong khi fetch profile
        try {
          const p = await getUserProfile(firebaseUser.uid);
          if (p?.active === false) {
            await logoutUser();
            return;
          }
          setProfile(p);
          if (p) setAuditActor({ name: p.name, role: p.role, uid: p.uid });
        } catch (err) {
          console.error("Lỗi tải profile từ Firestore:", err.message);
          setProfile(null);
        } finally {
          setLoading(false);
        }
      } else {
        setUser(null);
        setProfile(null);
        setLoading(false);
      }
    });
    return unsub;
  }, []);

  return (
    <AuthContext.Provider value={{ user, profile, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
